import { createAsyncThunk } from '@reduxjs/toolkit'
import { ResolveUrl } from 'features/firebase-app'
import { getBearerToken } from '../../application/application-slice'

//Add types for inputs later.
export const CreateItemPlayerRole_byPlayerAsync = createAsyncThunk<
  any,
  any,
  any
>(
  'composer/auto/playerRoleController/player/CreateItem/PlayerRole',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('auto/playerRoleController/player/CreateItem/PlayerRole'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: params !== undefined ? JSON.stringify(params) : null,
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)

//Add types for inputs later.
export const UpdateItemPlayerRole_byPlayerAsync = createAsyncThunk<
  any,
  any,
  any
>(
  'composer/auto/playerRoleController/player/UpdateItem/PlayerRole',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('auto/playerRoleController/player/UpdateItem/PlayerRole'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: params !== undefined ? JSON.stringify(params) : null,
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)

//Add types for inputs later.
export const DeleteItemPlayerRole_byPlayerAsync = createAsyncThunk<
  any,
  any,
  any
>(
  'composer/auto/playerRoleController/player/DeleteItem/PlayerRole',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('auto/playerRoleController/player/DeleteItem/PlayerRole'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: params !== undefined ? JSON.stringify(params) : null,
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)

//Add types for inputs later.
export const GetItemPlayerRole_byPlayerAsync = createAsyncThunk<any, any, any>(
  'composer/auto/playerRoleController/player/GetItem/PlayerRole',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('auto/playerRoleController/player/GetItem/PlayerRole'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: params !== undefined ? JSON.stringify(params) : null,
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)

//Add types for inputs later.
export const GetListPlayerRole_byPlayerAsync = createAsyncThunk<any, any, any>(
  'composer/auto/playerRoleController/player/GetList/PlayerRole',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('auto/playerRoleController/player/GetList/PlayerRole'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: params !== undefined ? JSON.stringify(params) : null,
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
